module.exports = __webpack_public_path__ + "static/media/hands.51ca7b06.svg";